<mat-slide-toggle
  [matTooltip]="readOnlyTooltipMessage"
  [checked]="cellParams?.isActive"
  [disabled]="cellParams?.readOnly"
  (change)="toggleSwitch($event)"
></mat-slide-toggle>
<span class="scope-toggle-align ml-2">{{ cellParams?.isActive ? 'Active' : 'Inactive' }}</span>
